export const Modals = {
  PARCEL_MANUAL: 'parcelManual',
  ONBOARDING_MANUAL: 'onboardingManual',
  CREATE_ACCOUNT: 'createAccount',
  DELETE_ACCOUNT: 'deleteAccount',
  LEAVE_THIS_PAGE: 'leaveThisPage',
  DELETE_ITEM: 'deleteItem',
  QUIT_EDIT_ITEM: 'quitEditItem',
  ALLOW_LOCATION_ACCESS: 'allowLocationAccess',
  CODE_GENERATION: 'codeGeneration',
  PAYMENT: 'payment',
  LEAVE_FEEDBACK: 'leaveFeedback',
  NO_DELIVERY_OPTION: 'noDeliveryOptionModal',
  SIGNATURE: 'signature',
  QR_ICON: 'qrIcon',
  LAUNCH_NOTIFICATION: 'launchNotification',
  INSURANCE_COVERAGE_CHANGE: 'insuranceCoverageChange',
  USER_SETTINGS_PHONE_VERIFICATION: 'userSettingsPhoneVerification',
  RESCHEDULE_PARCEL: 'rescheduleParcel',
  CROSS_SALE: 'crossSale',
  UNSUPPORTED_SHIPPING_DIRECTION: 'unsupportedShippingDirection',
  PARCEL_ITEMS_PHOTO_SELECTION: 'parcelItemsPhotoSelection',
  VOICE_RECORDING: 'voiceRecording',
  VERIFY_PHONE_NUMBER: 'verifyPhoneNumber',
} as const;
